
var data = {
    theoriticalSkills : [
      "Front-end development",
      "Back-end development",
      "Android Development",
      "Graphic Design / UX/UI design / Illustration",
      "Image Processing",
      "Business Intelligence",
      "Service Design",
      "Motion graphic",
      "Search Engine Optimization",
      "Storyboarding"
    ],
    softwareSkills : [
      {
        title: "Adobe",
        topics: [
          "Illustrator",
          "Photoshop",
          "InDesign",
          "AfterEffects",
          "PremierePro",
          "Flash",
          "UX", ]
      },
      {
        title: "Corel",
        topics: ["Draw", "Paint"]
      },
      {
        title: "Other",
        topics: [
          "Visual Studio / VS Code",
          "IntelliJ",
          "Android Studio",
          "Unity",
          "TVPaint",
          "3d Studio Max",
          "Blender",
          "Figma",
          "Gimp"
        ]
      }
    ],
    
    programmingSkills : [
      {
        title: "Languages",
        topics: [
          "HTML5 / CSS / SaSS",
          "JavaScript(ES6)",
          "TypeScript",
          "C#",
          "Java",
          "C / C++",
          "Python",
          "R",
          "SQL",
          "PHP"
        ]
      },
      {
        title: "Frameworks and Libraries",
        topics: [
          "React.js",
          "Vue.js / Vuex",
          "Angular 2/4",
          "Knockout",
          "Redux / React-Redux / Redux-Thunk / Redux-Saga",
          "Webpack",
          "GraphQL / Apollo-Server / GraphQL Yoga",
          "Node.js / Express.js / Socket.io",
          ".net core 2 / asp.net mvc 5 / asp.net Razor View",
          "ZeroMQ",
          "JavaFX / Swing",
          "OpenCV",
          "Processing",
          "jQuery",
        ]
      },
      {
        title: "Database",
        topics: ["mySQL", "MongoDB"]
      },
      {
        title: "CMS",
        topics: ["Wordpress"]
      },
      {
        title: "DevOps & Other",
        topics: ["Docker", "Heroku / Netlify / Digital Ocean / Amazon EC2","Git","npm","Unix CLI"]
      }
    ],
    
    works : [
    
        {
          type: "Founder and Lead Developer",
          date: "2018 - Now",
          company: "PAYAPAY",
          name: [{ type: "url", url: "https://payapay.io/en", name: "payapay.io" }],
          roles: ["Concept developer","Fullstack developer","UX/UI designer","Graphic designer"]
        },
      {
        type: "Front End Developer",
        date: "2015 - 2016",
        company: "QAtor A/S",
        name: [{ type: "url", url: "http://www.qator.com", name: "qator.com" }],
        roles: ["Graphic designer", "UX/UI designer", "Webdesigner and developer"]
      },
      {
        type: "Art Director",
        date: "2014",
        company: "Valo TV",
        name: [{ type: "url", url: "https://vimeo.com/valotv", name: "Visit ValoTV" }],
        roles: [
          "AD duties unifying Nordic culture materials for visual promotion products.",
          "Development of illustration to website and interactive presentations.",
          "Development of motion graphics e.g. video / live event themes",
          "Research to identify Nordic diversity and bridge intercultural communication."
        ]
      },
      {
        type: "Graphic Designer",
        date: "2014",
        company: "Openwire Exhibition",
        name: [
          { type: "url", url: "http://kopenhagen.dk/news/nyhed/article/open-wire-digital-sculptures-in-the-harbour-of-koege/", name: "Read more about OpenWire" }
        ],
        roles: [
          "Concept development of mobile application.",
          "UI/UX design, Graphic design"
        ]
      },
      {
        type: "Workshop teacher",
        date: "2012",
        company: "Bakkegårdsskolen",
        name: [
          {
            type: "url",
            url: "https://bakkegaard.skoleporten.dk/sp",
            name: "Visit school's website"
          }
        ],
        roles: [
          "Bringing different projects for the students in the workshop, in the field of visual design."
        ]
      },
      {
        type: "Freelance",
        date: "2011 - Present",
        name: [
          { type: "url", url: "http://www.switcherr.com", name: "switcherr.com" },
          { type: "url", url: "http://www.bmobilized.com", name: "bmobilized.com" }
        ],
        roles: [
          "Concept development",
          "Graphic, website designer, developer",
          "Motion graphics"
        ]
      }
    ],
    education: [
      {
        type: 'Computer Science and Informatics',
        level:"Master's degree",
        date: '2017 - 2019',
        school: 'Roskilde University',
        roles: [
          'Full Stack Development using ASP.NET Core with C#, Node.js , RESTfull API and JS frameworks',
          'Systems Architecture Design and Development',
          'Real Time multiplayer Game Development with Unity',
          'Big Data Analysis',
          'Mobile Development',
          'Theoretical Computer Science',
          'Digital Image Processing'

        ]
      },
      {
        type: 'Computer Science',
        level:"Bachelor's Supplementary Semester",
        date: '2017',
        school: 'Roskilde University',
        roles: [
         'Algorithms & Data Structures',
          'Advanced Programming in JAVA',
          'Interactive Digital Systems',
          'Micro Controllers and Robotics'
        ]
      },
      {
        type: 'Digital Concept Development',
        level:"Professional Bachelor degree",
        date: '2013 - 2015',
        school: 'Zealand Institute of Business and Technology',
        roles: [
          'Digital Design / Interaction Design',
          'User Research / User Experience Design',
          'Project Management',
          'E-business',
        ]
      },
      {
        type: 'Multimedia Design and Communication',
        level:"Academic Profession",
        date: '2008 - 2010',
        school: 'Kea Copenhagen School of Design and Technology',
        roles: [
          'Web Development',
          'Digital Design',
          'Digital Communication',
          'Video Editing',
        ]
      }
    ],
    languageSkills : [
      "English (Fluent)",
      "Danish (Fluent)",
      "Persian (Native)",
      "French (Beginner)",
    ],
    certificates : [
      "GxP (QAtor A/S)",
      "ASP.NET MVC 5 (ITUCATION)"
    ]
    
    }

    export default data;